import React from "react";
import ModalButtons from "../ModalButtons/ModalButtons";
import NightAuditNavigation from "../NightAudit/NightAuditNavigation";
import NightAuditFolioItemsPresenter from "./steps/NightAuditFolioItemsPresenter/NightAuditFolioItemsPresenter";
import NightAuditPaymentsPresenter from "./steps/NightAuditPaymentsPresenter/NightAuditPaymentsPresenter";
import NightAuditAuthorizationsPresenter from "./steps/NightAuditAuthorizationsPresenter/NightAuditAuthorizationsPresenter";
import NightAuditNoShowsPresenter from "./steps/NightAuditNoShowsPresenter/NightAuditNoShowsPresenter";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import numeral from "numeral";

class NightAuditPresenter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 'folio_items',
    };
    this.changeStep = this.changeStep.bind(this);
  };

  render() {
    return(
      <div className="night-audit NightAudit">
        <NightAuditNavigation step={this.state.step}
          changeStep={this.changeStep}
          read_only={this.props.read_only}
        />
        <br />
        {this.renderSteps()}
        <ModalButtons loading={this.state.loading} buttons={this.setButtons()} />
        <LoadingSpinner show={this.state.loading} />
      </div>
    );
  };

  renderSteps(){
    switch(true) {
      case this.state.step === 'folio_items': return <NightAuditFolioItemsPresenter {...this.props} formatCurrency={this.formatCurrency} />
      case this.state.step === 'payments': return <NightAuditPaymentsPresenter {...this.props} formatCurrency={this.formatCurrency} />
      case this.state.step === 'cc_authorizations': return <NightAuditAuthorizationsPresenter {...this.props} formatCurrency={this.formatCurrency} />
      case this.state.step === 'no_shows': return <NightAuditNoShowsPresenter {...this.props} formatCurrency={this.formatCurrency} />
    };
  };

  setButtons() {
    if (this.state.step === "folio_items") {
      var buttons = [
        {
          name: I18n.t('close'),
          html_attributes: [
            'data-dismiss="modal"'
          ]
        },
        {
          name: I18n.t('next'),
          onClick: (e) => {
            this.setState({
              step: "payments",
            });
          }
        }
      ];
    } else if (this.state.step === "payments") {
      var buttons = [
        {
          name: I18n.t('prev'),
          onClick: (e) => {
            this.setState({
              step: "folio_items",
            });
          }
        },
        {
          name: I18n.t('next'),
          onClick: (e) => {
            this.setState({
              step: "cc_authorizations",
            });
          }
        }
      ];
    } else if (this.state.step === "cc_authorizations") {
      var buttons = [
        {
          name: I18n.t('prev'),
          onClick: (e) => {
            this.setState({
              step: "payments",
            });
          }
        },
        {
          name: I18n.t('next'),
          onClick: (e) => {
            this.setState({
              step: "no_shows",
            });
          }
        }
      ];
    } else if (this.state.step === "no_shows") {
      var buttons = [
        {
          name: I18n.t('prev'),
          onClick: (e) => {
            this.setState({
              step: "cc_authorizations",
            });
          }
        },
        {
          name: I18n.t('close'),
          html_attributes: [
            'data-dismiss="modal"'
          ]
        },
      ];
    }
    return buttons
  };


  formatCurrency(num) {
    return I18n.t('number.currency.format.unit') + numeral(num / 100).format('0' + I18n.t('number.currency.format.delimiter') + '0.00');
  };

  changeStep(stepName) {
    this.setState({
      step: stepName,
    });
  };

};

export default NightAuditPresenter
